<div class="container">
  <div class="row justify-content-center">
    <div class="col-lg-9 col-md-12">
      <br>
      <div #alert class="alert alert-primary alert-dismissible fade" role="alert" style="text-align: center;">
        <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
          <span aria-hidden="true">&times;</span>
        </button>
        <strong>Q&A</strong> posted successfully!
      </div>
    </div>
    <div class="col-md-12 col-lg-9" *ngIf="postQuestion==false">
      <br>
      <h3 style="text-align: center;">Search Answers for MCQ questions</h3>
      <form #f="ngForm" class="form-inline md-form mr-auto mb-4 justify-content-center" style="text-align: center;"
        (ngSubmit)="searchQuestion(f)">

        <input autocomplete="off" name="question" ngModel required #question mdbInput class="form-control mr-sm-2 w-100"
          type="text" placeholder="Search question.." aria-label="Search">
        <!-- <button mdbBtn size="sm" color="primary" rounded="true" rounded="true" class="my-0 waves-light" mdbWavesEffect type="submit">Search</button> -->
        <button type="submit" mdbBtn size='md' class="my-0 waves-light" color="primary" rounded="true" outline="true"
          mdbWavesEffect>Search</button>
        <button [routerLink]="'/post'" size='md' mdbBtn class="my-0 waves-light" type="button" color="success"
          rounded="true" outline="true" mdbWavesEffect>Post Q & A</button>
      </form>
      <div *ngIf="loading" class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div> <br>
      <!--
      <div class="list-group" *ngFor="let r of result;let i=index">

        <a  class="list-group-item list-group-item-action flex-column align-items-start" >
          <div class="d-flex w-100 justify-content-between">
            <p class="mb-1"><b>Question : </b> {{r.question}}</p>
          </div>
          <p class="mb-1"> <b>Answer : </b> {{r.answer}}</p>
          <small class="text-muted">posted {{r.dateFromNow}}</small>
        </a>
      </div> -->

      <mdb-card *ngIf="!loading">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let r of result;let i=index">
            <div class="container justify-content-center">
            <div class="row">

              <div class="col-12 col-sm-11">
                <p><b>Question : </b> {{r.question}}</p>
                <p><b>Answer : </b> {{r.answer}}</p>
                 <div class="d-sm-none d-block"><!-- mobile view -->
                  <div style="text-align: right;">
                    <small class="text-muted mb-2" style="float: left;">posted {{r.dateFromNow}}</small>
                    <!-- <a  style="float: left;font-size: 15px;" href="https://wa.me/?text=*Question* : {{r.question}}%0A*Answer* : {{r.answer}}"><i class="fab fa-whatsapp"></i>  Share via Whatsapp</a> -->
                    <a (click)="upvote(i,'limegreen')"><i class="fas fa-arrow-up fa-lg {{r._id}}" style="color: grey;" ></i></a>
                    <span class="{{r._id}}" style="white-space: nowrap;padding-left: 4px;padding-right: 4px;">{{r.upvote-r.downvote}}</span>
                    <a (click)="downvote(i,'black')">
                      <i class="fas fa-arrow-down fa-lg {{r._id}}" style="color: grey;"></i></a>
                  </div>
                </div>
                <small class="text-muted mb-2 d-none d-sm-block">posted {{r.dateFromNow}}</small>
              </div>
              <div class="col-sm-1 d-sm-block d-none">
                <div style="text-align: center;">
                  <a (click)="upvote(i,'limegreen')"><i class="fas fa-arrow-up fa-lg {{r._id}}" style="color: grey;" ></i></a> <br>
                  <span class="{{r._id}}" style="white-space: nowrap;">{{r.upvote-r.downvote}}</span> <br>
                  <a (click)="downvote(i,'black')">
                    <i class="fas fa-arrow-down fa-lg {{r._id}}" style="color: grey;"></i></a> <br>
                </div>
              </div>
              <div class="col-12">
                <a href="https://wa.me/?text=*Question* : {{r.question}}%0A*Answer* : {{r.answer}}" target="_blank"><i class="fab fa-whatsapp" style="color: #4FCE5D;"></i>  Share via Whatsapp</a>

              </div>

            </div>
          </div>
          </li>
        </ul>

      </mdb-card>

      <p *ngIf="empty && !loading" style="text-align: center;">No results...</p>

    </div>
    <div class="col-md-8 col-sm-12" *ngIf="postQuestion">

      <mdb-card>

        <mdb-card-header class="indigo white-text text-center py-4">
          <h5>
            <strong>Post Q&A</strong>
          </h5>
        </mdb-card-header>
        <mdb-card-body class="px-lg-5 pt-0">
          <form #f2="ngForm" (ngSubmit)="postQA(f2)" style="text-align: center;">
            <!-- Grid row -->
            <div class="form-row">
              <!-- Grid column -->
              <div class="col-md-12">
                <!-- Material input -->
                <div class="md-form form-group">
                  <div class="md-form md-outline">
                    <textarea ngModel required #postQuestion name="postQuestion" type="text" id="form75"
                      class="form-control md-textarea" rows="3" mdbInput style="resize: none;"></textarea>
                    <label for="form75">Question</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="md-form form-group">
                  <div class="md-form md-outline">
                    <textarea ngModel required #postAnswer name="postAnswer" type="text" id="form75"
                      class="form-control md-textarea" rows="3" mdbInput style="resize: none;"></textarea>
                    <label for="form75">Answer</label>
                  </div>
                </div>
              </div>

            </div>

            <button mdbBtn type="submit" color="primary" outline="true" mdbWavesEffect>Post</button>
          </form>
        </mdb-card-body>
      </mdb-card>

    </div>
  </div>
</div>
